import script from "./PostManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./PostManagement.vue?vue&type=script&setup=true&lang=js"

import "./PostManagement.vue?vue&type=style&index=0&id=1cecb3df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cecb3df"]])

export default __exports__